import { Controller } from "@hotwired/stimulus";

type FieldOption = [string, string];

export default class extends Controller<HTMLElement> {
  static targets = ["integration", "field"];
  static values = { options: Object };

  declare readonly integrationTarget: HTMLSelectElement;
  declare readonly fieldTarget: HTMLSelectElement;
  declare readonly optionsValue: Record<string, FieldOption[]>;

  connect() {
    this.change();
  }

  change() {
    const selectedIntegrationId = this.integrationTarget.value;
    const options = this.optionsValue[selectedIntegrationId] || [];
    const currentValue = this.fieldTarget.value;

    this.fieldTarget.replaceChildren(
      ...options.map(([label, value]) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = label;
        return option;
      })
    );

    if (options.some(([, value]) => value === currentValue)) {
      this.fieldTarget.value = currentValue;
    }
  }
}
